// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import theme from '../../styled-components/dark';
import { NewTag } from '../../styled-components/shared';
import { SportsMenuListItem } from '../../styled-components/shared';
import type { SportId } from '../../types/sports';
import ExpandArrow from '../ExpandArrow';
import FlagIcon from '../FlagIcon';
import SportIcon from '../SportIcon';

const StyledListItem = styled(SportsMenuListItem)`
  padding-left: ${({ $padding }) => ($padding ? `${$padding * 2}em` : undefined)};
  ${Target.__MOBILE__
    ? css`
        letter-spacing: normal;
      `
    : undefined}
`;

const StyledNewTag = styled(NewTag)`
  position: absolute;
  right: 3em;
`;

const StyledSportIcon = styled(SportIcon)`
  margin: 0 0.7em 0 0.2em;
`;
const StyledFlagIcon = styled(FlagIcon)`
  margin-right: 1em;
  margin-left: 0.5em;
`;

const ListItemLabel = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;

  margin-left: ${({ $margin }) => ($margin ? '2.8em' : undefined)};

  border-bottom: ${({ $border, $nextIsOpen }) =>
    $border ? `1px solid ${$nextIsOpen ? 'transparent' : theme.SportsMenuListItem.separatorColor}` : undefined};
`;

const StyledExpandArrow = styled(ExpandArrow)`
  position: absolute;
  right: 0.55em;
  height: 0.55em;
  width: 1.5em;

  & .sports-arrow-inner-group {
    stroke: ${theme.SportsMenuListItem.arrowColor};
  }
`;

const StyledSeeAllArrow = styled(ExpandArrow)`
  position: absolute;
  right: 0.7em;
  height: 1em;
  width: 1em;
  transition: transform 150ms ease-in-out;
  transform: rotate(90deg);

  & .sports-arrow-inner-group {
    stroke: ${theme.SportsMenuListItem.arrowColor};
  }
`;

type SportsMenuSportsListItemProps = {
  depth: number;
  isOpened: boolean;
  nextIsOpen: boolean;
  label: string;
  border: boolean;
  sportId?: SportId;
  flagId?: string;
  expandable?: boolean;
  showNewTag?: boolean;
  onClickConfig: { onClick: () => void } | { onClick: () => void; to: void | string };
};

const SportsMenuSportsListItem = ({
  depth,
  isOpened,
  nextIsOpen,
  label,
  border,
  sportId,
  flagId,
  expandable = false,
  showNewTag = false,
  onClickConfig,
}: SportsMenuSportsListItemProps) => {
  const renderedSportIcon = useMemo(() => (sportId ? <StyledSportIcon sportId={sportId} /> : null), [sportId]);
  const renderedFlagIcon = useMemo(() => (flagId ? <StyledFlagIcon flagId={flagId} /> : null), [flagId]);

  const renderedArrow = useMemo(
    () => (expandable ? <StyledExpandArrow $isExpanded={isOpened} /> : <StyledSeeAllArrow className="see-all-btn" />),
    [expandable, isOpened],
  );

  return (
    <StyledListItem depth={depth} $padding={depth} {...onClickConfig}>
      {renderedSportIcon}
      {renderedFlagIcon}
      <ListItemLabel $border={border} $nextIsOpen={nextIsOpen} $margin={!!depth && !sportId && !flagId}>
        {label}
      </ListItemLabel>
      {renderedArrow}
      {showNewTag ? <StyledNewTag>New</StyledNewTag> : null}
    </StyledListItem>
  );
};

export default React.memo<SportsMenuSportsListItemProps>(SportsMenuSportsListItem);
